export enum AlertType {
    DEFAULT = 'dfb-Alert--default',
    SECONDARY = 'dfb-Alert--secondary',
    SUCCESS = 'dfb-Alert--success',
    SUCCESS_SECONDARY = 'dfb-Alert--success dfb-Alert--secondary',
    ERROR = 'dfb-Alert--error',
    ERROR_SECONDARY = 'dfb-Alert--error dfb-Alert--secondary'
}
